<template>


    <v-tabs
            color="secondary"
            dark
            slider-color="primary"
            show-arrows
    >

        <!--Account TAB-->
        <v-tab to="/settings/account" ripple>
            Account
        </v-tab>
        <!--Customers TAB-->
        <v-tab to="/settings/customers" ripple>
            Customers
        </v-tab>
        <!--Suppliers TAB-->
        <v-tab to="/settings/suppliers" ripple>
            Suppliers
        </v-tab>
        <!--Manufacturers TAB-->
        <v-tab to="/settings/manufacturers" ripple>
            Manufacturers
        </v-tab>
        <!--Products TAB-->
        <v-tab to="/settings/products" ripple>
            Products
        </v-tab>
        <!--Contact Functions TAB-->
        <v-tab to="/settings/contactFunctions" ripple>
            Contact Functions
        </v-tab>
        <!--Terms Of Delivery TAB-->
        <v-tab to="/settings/termsOfDeliveries" ripple>
            Terms Of Delivery
        </v-tab>
        <!--Terms Of Payment TAB-->
        <v-tab to="/settings/termsOfPayments" ripple>
            Terms Of Payment
        </v-tab>
        <!--Users Functions TAB-->
        <v-tab to="/settings/users" ripple>
            Users
        </v-tab>
        <!--Brand Configurations TAB-->
        <v-tab to="/settings/brandConfiguration" ripple>
            Brand Configuration
        </v-tab>

        <!--Cash Flow TAB-->
        <v-tab to="/settings/cashFlow" ripple>
            Cash Flow
        </v-tab>


    </v-tabs>
</template>

<script>
    export default {
      name: 'SettingsNav'
        /*      props: {
                active: Number,
                default: 2
              },
              computed: {
                getActiveTab: {
                  get () {
                    console.log('get getActiveTab: ' + this.active)
                    return this.active
                  },
                  set () {
                    console.log('set getActiveTab: ' + this.active)
                  }

                }
              } */

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Shared/SettingsNav.vue